import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import ReceivedPaymentModal from './ReceivedPaymentModal';

const ReceivedPayment = () => {


    // State Variables
    const [searchQuery, setSearchQuery] = useState('');
    const [customers, setCustomers] = useState([
        { name: 'John Doe', startDate: '2023-01-01', endDate: '2023-01-15', transactionId: 'TXN12345', duration: '15 days', amount: 1000, date: '2023-01-01', mode: 'Credit Card', status: 'Completed' },
        { name: 'Jane Smith', startDate: '2023-02-01', endDate: '2023-02-10', transactionId: 'TXN67890', duration: '10 days', amount: 500, date: '2023-02-01', mode: 'Net Banking', status: 'Pending' },
        { name: 'Alice Brown', startDate: '2023-03-05', endDate: '2023-03-20', transactionId: 'TXN11223', duration: '15 days', amount: 1200, date: '2023-03-05', mode: 'UPI', status: 'Completed' },
    ]);
    const [filteredCustomers, setFilteredCustomers] = useState(customers);
    const [currentPage, setCurrentPage] = useState(1);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const itemsPerPage = 10;

    // Effect to handle filtering
    useEffect(() => {
        const filtered = customers.filter((customer) =>
            Object.values(customer).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredCustomers(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchQuery, customers]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredCustomers.length / itemsPerPage);
    const currentData = filteredCustomers.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Handle Delete
    const handleDelete = (indexToDelete) => {
        const updatedCustomers = customers.filter((_, index) => index !== indexToDelete);
        setCustomers(updatedCustomers);
    };

    return (
        <>
            <div className="oms-header">
                <h1 className="dashboard-title">Received Payments</h1>
                <button className="oms-add-btn" onClick={() => setIsModalOpen(true)}>
                    Add Fees
                </button>
            </div>

            {/* Search Filter */}
            <div className="filter-search">
                <div className="filter-search-input">
                    <input
                        type="search"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                    />
                    <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                </div>
            </div>

            {/* Customer Table */}
            <div className="customer-table">
                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Transaction ID</th>
                            <th>Duration</th>
                            <th>Amount</th>
                            <th>Date</th>
                            <th>Mode</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentData.length > 0 ? (
                            currentData.map((customer, index) => (
                                <tr key={index}>
                                    <td>{customer.name}</td>
                                    <td>{customer.startDate}</td>
                                    <td>{customer.endDate}</td>
                                    <td>{customer.transactionId}</td>
                                    <td>{customer.duration}</td>
                                    <td>{customer.amount}</td>
                                    <td>{customer.date}</td>
                                    <td>{customer.mode}</td>
                                    <td>{customer.status}</td>
                                    <td>
                                        <button className="edit-button" onClick={() => setIsModalOpen(true)}><i className="fa-solid fa-pencil edit-oms"></i></button>
                                        <button
                                            className="delete-button"
                                            onClick={() => handleDelete(index)}
                                        >
                                            <i className="fa-solid fa-trash delete-oms"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="10" style={{ textAlign: 'center' }}>No customers found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            <div className="pagination">
                <button
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    Previous
                </button>
                {Array.from({ length: totalPages }, (_, index) => (
                    <button
                        key={index}
                        onClick={() => paginate(index + 1)}
                        className={currentPage === index + 1 ? 'active' : ''}
                    >
                        {index + 1}
                    </button>
                ))}
                <button
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    Next
                </button>
            </div>

            <ReceivedPaymentModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
        </>
    );
};

export default ReceivedPayment;
